import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';
import { Observable }                                        from 'rxjs/Observable';
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { environment } from '../../environments/environment';
import { ProviderDataModel, VisitTypesDataModel, LocationDataModel, DatesWithAvailableSlotsDataModel, AppointmentDataAPIModel, SendEmailDataModel } from '../model/requestAppointmentData';

@Injectable()
export class RequestAppointmentService {

    protected basePath = environment.appSetting.apiUrl;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

      /**
     * Referenced to SOA.GetProvidersByLocation
     * This API get GetProvidersByLocation
     * @param referalFlag referalFlag
     * @param locationId locationId
     * @param activeStatus activeStatus
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
      public GetProvider(referalFlag: number, activeStatus: number ,menuId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ProviderDataModel>>;
      public GetProvider(referalFlag: number, activeStatus: number ,menuId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProviderDataModel>>>;
      public GetProvider(referalFlag: number, activeStatus: number ,menuId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProviderDataModel>>>;
      public GetProvider(referalFlag: number, activeStatus: number ,menuId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        //   if (statementId === null || statementId === undefined) {
        //       throw new Error('Required parameter statementId was null or undefined when calling PatientStatementModel.');
        //   }
  
          let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
          //if (statementId !== undefined && statementId !== null) {
          //    queryParameters = queryParameters.set('statementId', <any>statementId);
          //}
  
          let headers = this.defaultHeaders;
  
          // authentication (api_key) required
          if (this.configuration.apiKeys["Context"]) {
              headers = headers.set('Context', this.configuration.apiKeys["Context"]);
          }
  
          // authentication (idp_auth) required
          if (this.configuration.accessToken) {
              const accessToken = typeof this.configuration.accessToken === 'function'
                  ? this.configuration.accessToken()
                  : this.configuration.accessToken;
              headers = headers.set('Authorization', 'Bearer ' + accessToken);
          }
  
          // to determine the Accept header
          let httpHeaderAccepts: string[] = [
              'application/json',
              'application/xml'
          ];
          const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
          if (httpHeaderAcceptSelected != undefined) {
              headers = headers.set('Accept', httpHeaderAcceptSelected);
          }
  
          // to determine the Content-Type header
          const consumes: string[] = [
              'application/json',
              'application/xml'
          ];
          headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,PATCH,OPTIONS');
          return this.httpClient.get<ProviderDataModel>(`${this.basePath}practice/GetProviders?referalFlag=`+ referalFlag + '&activeStatus=' + activeStatus + '&menuId=' + menuId,
          //return this.httpClient.get<PatientStatementModel>(`${this.basePath}/Statement`,
              {
                  params: queryParameters,
                  withCredentials: this.configuration.withCredentials,
                  headers: headers,
                  observe: observe,
                  reportProgress: reportProgress
              }
          );
      }

      /**
 * Referenced to Practice.GetProvidersByLocation
 * This API gets all providers by location
 * @param locationId locationId
 */

public GetAllProvidersByLocation(locationId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ProviderDataModel>>;
public GetAllProvidersByLocation(locationId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProviderDataModel>>>;
public GetAllProvidersByLocation(locationId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProviderDataModel>>>;
public GetAllProvidersByLocation(locationId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    if (locationId === null || locationId === undefined) {
        throw new Error('Required parameter locationId was null or undefined when calling GetAllProvidersByLocation.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

    let headers = this.defaultHeaders;

    // authentication (Context) required
    if (this.configuration.apiKeys["Context"]) {
        headers = headers.set('Context', this.configuration.apiKeys["Context"]);
    }

    // authentication (Bearer token) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }

    // Accept header
    let httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,PATCH,OPTIONS');

    return this.httpClient.get<Array<ProviderDataModel>>(
        `${this.basePath}practice/GetAllProvidersByLocation?locationId=` + locationId,
        {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
}
       /**
     * Referenced to SOA.GetVisitTypes
     * This API get GetVisitTypes
     * @param facilityVisitFlag referalFlag
     * @param activeStatus activeStatus
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
       public GetVisitTypes(facilityVisitFlag: number, activeStatus: number, bookOnline: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<VisitTypesDataModel>>;
       public GetVisitTypes(facilityVisitFlag: number, activeStatus: number, bookOnline: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<VisitTypesDataModel>>>;
       public GetVisitTypes(facilityVisitFlag: number, activeStatus: number, bookOnline: boolean,observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<VisitTypesDataModel>>>;
       public GetVisitTypes(facilityVisitFlag: number, activeStatus: number, bookOnline: boolean,observe: any = 'body', reportProgress: boolean = false): Observable<any> {
         //   if (statementId === null || statementId === undefined) {
         //       throw new Error('Required parameter statementId was null or undefined when calling PatientStatementModel.');
         //   }
   
           let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
           //if (statementId !== undefined && statementId !== null) {
           //    queryParameters = queryParameters.set('statementId', <any>statementId);
           //}
   
           let headers = this.defaultHeaders;
   
           // authentication (api_key) required
           if (this.configuration.apiKeys["Context"]) {
               headers = headers.set('Context', this.configuration.apiKeys["Context"]);
           }
   
           // authentication (idp_auth) required
           if (this.configuration.accessToken) {
               const accessToken = typeof this.configuration.accessToken === 'function'
                   ? this.configuration.accessToken()
                   : this.configuration.accessToken;
               headers = headers.set('Authorization', 'Bearer ' + accessToken);
           }
   
           // to determine the Accept header
           let httpHeaderAccepts: string[] = [
               'application/json',
               'application/xml'
           ];
           const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
           if (httpHeaderAcceptSelected != undefined) {
               headers = headers.set('Accept', httpHeaderAcceptSelected);
           }
   
           // to determine the Content-Type header
           const consumes: string[] = [
               'application/json',
               'application/xml'
           ];
           headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,PATCH,OPTIONS');
           return this.httpClient.get<ProviderDataModel>(`${this.basePath}patientcare/GetVisitTypes?facilityVisitFlag=`+ facilityVisitFlag + '&activeStatus=' + activeStatus + '&bookOnline=' + bookOnline,
               {
                   params: queryParameters,
                   withCredentials: this.configuration.withCredentials,
                   headers: headers,
                   observe: observe,
                   reportProgress: reportProgress
               }
           );
       }

          /**
     * Referenced to SOA.GetLocations
     * This API get GetLocations
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
          public GetLocation(observe?: 'body', reportProgress?: boolean): Observable<Array<LocationDataModel>>;
          public GetLocation(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LocationDataModel>>>;
          public GetLocation(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LocationDataModel>>>;
          public GetLocation(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
            //   if (statementId === null || statementId === undefined) {
            //       throw new Error('Required parameter statementId was null or undefined when calling PatientStatementModel.');
            //   }
      
              let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
              //if (statementId !== undefined && statementId !== null) {
              //    queryParameters = queryParameters.set('statementId', <any>statementId);
              //}
      
              let headers = this.defaultHeaders;
      
              // authentication (api_key) required
              if (this.configuration.apiKeys["Context"]) {
                  headers = headers.set('Context', this.configuration.apiKeys["Context"]);
              }
      
              // authentication (idp_auth) required
              if (this.configuration.accessToken) {
                  const accessToken = typeof this.configuration.accessToken === 'function'
                      ? this.configuration.accessToken()
                      : this.configuration.accessToken;
                  headers = headers.set('Authorization', 'Bearer ' + accessToken);
              }
      
              // to determine the Accept header
              let httpHeaderAccepts: string[] = [
                  'application/json',
                  'application/xml'
              ];
              const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
              if (httpHeaderAcceptSelected != undefined) {
                  headers = headers.set('Accept', httpHeaderAcceptSelected);
              }
      
              // to determine the Content-Type header
              const consumes: string[] = [
                  'application/json',
                  'application/xml'
              ];
              headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,PATCH,OPTIONS');
              return this.httpClient.get<ProviderDataModel>(`${this.basePath}security/GetOnlineLocations`,
                  {
                      params: queryParameters,
                      withCredentials: this.configuration.withCredentials,
                      headers: headers,
                      observe: observe,
                      reportProgress: reportProgress
                  }
              );
          }
        /**
     * Referenced to SOA.GetEarliestDatesWithAvailableSlotsCount
     * This API get GetEarliestDatesWithAvailableSlotsCount
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
        public GetAvailableSlots(startDate: string, locationId: number, providerId:number, visitTypeId: number, observe?: 'body', reportProgress?: boolean): Observable<DatesWithAvailableSlotsDataModel>;
        public GetAvailableSlots(startDate: string, locationId: number, providerId:number, visitTypeId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DatesWithAvailableSlotsDataModel>>;
        public GetAvailableSlots(startDate: string, locationId: number, providerId:number, visitTypeId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DatesWithAvailableSlotsDataModel>>;
        public GetAvailableSlots(startDate: string, locationId: number, providerId:number, visitTypeId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
          //   if (statementId === null || statementId === undefined) {
          //       throw new Error('Required parameter statementId was null or undefined when calling PatientStatementModel.');
          //   }
    
            let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
            //if (statementId !== undefined && statementId !== null) {
            //    queryParameters = queryParameters.set('statementId', <any>statementId);
            //}
    
            let headers = this.defaultHeaders;
    
            // authentication (api_key) required
            if (this.configuration.apiKeys["Context"]) {
                headers = headers.set('Context', this.configuration.apiKeys["Context"]);
            }
    
            // authentication (idp_auth) required
            if (this.configuration.accessToken) {
                const accessToken = typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
                headers = headers.set('Authorization', 'Bearer ' + accessToken);
            }
    
            // to determine the Accept header
            let httpHeaderAccepts: string[] = [
                'application/json',
                'application/xml'
            ];
            const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
            if (httpHeaderAcceptSelected != undefined) {
                headers = headers.set('Accept', httpHeaderAcceptSelected);
            }
    
            // to determine the Content-Type header
            const consumes: string[] = [
                'application/json',
                'application/xml'
            ];
            headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,PATCH,OPTIONS');
            return this.httpClient.get<ProviderDataModel>(`${this.basePath}patientcare/GetEarliestDatesWithAvailableSlotsCount?startDate=` + startDate + '&locationId=' + locationId + '&providerId=' + providerId + '&visitTypeId=' + visitTypeId,
                {
                    params: queryParameters,
                    withCredentials: this.configuration.withCredentials,
                    headers: headers,
                    observe: observe,
                    reportProgress: reportProgress
                }
            );
        }

         /**
     * Referenced to SOA.PatientPortalSendMessage
     * This API Sends message
     * @param messageboard Message box
     * @param practiceCode Set Practice value
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public requestAppointment(appointmentData: AppointmentDataAPIModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public requestAppointment(appointmentData: AppointmentDataAPIModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public requestAppointment(appointmentData: AppointmentDataAPIModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public requestAppointment(appointmentData: AppointmentDataAPIModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        
        if (appointmentData === null || appointmentData === undefined) {
            throw new Error('Required parameter appointmentData was null or undefined when calling requestAppointment.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}patientcare/SaveOnlineScheduleAppointment`,
        appointmentData,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


        /**
     * Referenced to SOA.sendEmail
     * This API Sends message
     * @param messageboard Message box
     */
        public sendEmail(sendEmailData: SendEmailDataModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
        public sendEmail(sendEmailData: SendEmailDataModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
        public sendEmail(sendEmailData: SendEmailDataModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
        public sendEmail(sendEmailData: SendEmailDataModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
            
            if (sendEmailData === null || sendEmailData === undefined) {
                throw new Error('Required parameter sendEmailData was null or undefined when calling sendEmail.');
            }
    
            let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    
            let headers = this.defaultHeaders;
    
            // authentication (api_key) required
            if (this.configuration.apiKeys["Context"]) {
                headers = headers.set('Context', this.configuration.apiKeys["Context"]);
            }
    
            // authentication (idp_auth) required
            if (this.configuration.accessToken) {
                const accessToken = typeof this.configuration.accessToken === 'function'
                    ? this.configuration.accessToken()
                    : this.configuration.accessToken;
                headers = headers.set('Authorization', 'Bearer ' + accessToken);
            }
    
            // to determine the Accept header
            let httpHeaderAccepts: string[] = [
                'application/json',
                'application/xml'
            ];
            const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
            if (httpHeaderAcceptSelected != undefined) {
                headers = headers.set('Accept', httpHeaderAcceptSelected);
            }
    
            // to determine the Content-Type header
            const consumes: string[] = [
                'application/json',
                'application/xml'
            ];
            const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
            if (httpContentTypeSelected != undefined) {
                headers = headers.set('Content-Type', httpContentTypeSelected);
            }
    
            return this.httpClient.post<any>(`${this.basePath}patientportal/PatientPortalSendEmail`,
            sendEmailData,
                {
                    params: queryParameters,
                    withCredentials: this.configuration.withCredentials,
                    headers: headers,
                    observe: observe,
                    reportProgress: reportProgress
                }
            );
        }

}